module.exports = __webpack_public_path__ + "img/qrcode2.d9ff191c.png";